"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function HideOnScroll(props) {
  const {
    children
  } = props;
  const trigger = (0, _core.useScrollTrigger)();
  return /*#__PURE__*/_react.default.createElement(_core.Slide, {
    appear: false,
    direction: "down",
    in: !trigger
  }, children);
}
HideOnScroll.propTypes = {
  children: _propTypes.default.element.isRequired
};
var _default = exports.default = HideOnScroll;